<div content>
  <app-hello-there></app-hello-there><br /><br />
  <ng-container *ngIf="unauthorizePageData$ | async as data">
    <sh-text size="super-header">
      {{ data.title }}
    </sh-text>
    <br />

    <sh-text size="body-1" color="title-2">
      <span [innerHTML]="data.subText"></span>
    </sh-text>

    <br />
    <sh-text size="body-1" color="title-2">
      <div [innerHTML]="data.stepsToGetRole"></div>
    </sh-text>
    <br />

    <sh-button
      id="GamaRole-button"
      [label]="data.buttonText"
      icon="arrow"
      icon-position="left"
      size="max-content"
      (click)="openLink(data.buttonLink)"
    >
    </sh-button>
  </ng-container>
</div>
<div img>
  <div logo></div>
</div>
